import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Backdrop, Box, Button, Card, CircularProgress, FormControlLabel, Grid, IconButton, Modal, Radio, RadioGroup, Stack, Tooltip, Typography } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async';
import CompleteButton from 'src/components/shared/CompleteButton';
import moment from 'moment';
import Services from 'src/services/Services';
import { toast } from 'react-toastify';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useLocalization } from 'src/context/LocalizationContext';

export default function CreateReport() {

    const { language } = useLocalization();
    const parsedUser = JSON.parse(localStorage.getItem('user'));

    const [option, setOption] = useState("created");
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [isBackdropOpen, setIsBackdropOpen] = useState(false);
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleChangeOption = (event) => {
        setOption(event.target.value)
    }

    function formatDate(date) {
        date = new Date(date)
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const handleCreateReport = () => {
        setIsBackdropOpen(true)
        Services.GetReport(parsedUser.token, option, formatDate(startDate), formatDate(endDate))
            .then((response) => {
                if (response.data.status) {
                    setIsBackdropOpen(false)
                    window.open(response.data.result, '_blank');
                }
                else {
                    setIsBackdropOpen(false)
                    toast.error("Rapor oluşturuluracak veri mevcut değil.");
                }
            })
            .catch((error) => {
                setIsBackdropOpen(false)
                toast.error("Rapor oluşturulurken bir sorunla karşılaşıldı!");
                console.log(error);
            });
    }

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: 1, flexDirection: 'column', display: 'flex', gap: '50px' }} open={isBackdropOpen}>
                <Typography>{language.create_report.titles.info_download}</Typography>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Helmet>
                <title>{language.create_report.titles.site_title}</title>
            </Helmet>

            <Stack style={{ paddingInline: '25px' }}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={5}
                >
                    <Typography variant="h4" gutterBottom>
                    {language.create_report.titles.title}
                    </Typography>
                </Stack>
                <Card>
                    <Stack
                        direction="column"
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        paddingY={2}
                        paddingX={2}
                    >
                        <Grid item md={6} xs={12}>
                            <Typography variant="h6">{language.create_report.titles.report_type}</Typography>
                            <RadioGroup
                                sx={{ marginTop: '32px' }}
                                aria-label={language.create_report.titles.report_type}
                                name="option"
                                value={option}
                                onChange={handleChangeOption}
                                row
                            >
                                <FormControlLabel value="created" control={<Radio />} label={language.commons.labels.created_report} />
                                <FormControlLabel value="inBranch" control={<Radio />} label={language.commons.labels.inBranch_report} />
                                <FormControlLabel value="delivered" control={<Radio />} label={language.commons.labels.delivered_report} />
                                <FormControlLabel value="completed" control={<Radio />} label={language.commons.labels.completed_report} />
                            </RadioGroup>
                        </Grid>

                        <Grid container alignItems="center" xs={8} spacing={2} sx={{ marginTop: '32px' }}>
                            <Grid item>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DatePicker
                                        format="DD/MM/YYYY"
                                        label={language.commons.labels.report_start_date}
                                        value={startDate}
                                        onChange={(newValue) => setStartDate(newValue)}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DatePicker
                                        format="DD/MM/YYYY"
                                        label={language.commons.labels.report_end_date}
                                        value={endDate}
                                        onChange={(newValue) => setEndDate(newValue)}
                                        disabled={!startDate}
                                        minDate={moment(startDate)}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item>
                                <CompleteButton sx={{ height: '54px' }} disabled={!(startDate && endDate) || (startDate > endDate)} label={"Rapor Oluştur"} onClick={handleCreateReport} />
                                {!(startDate && endDate) || (startDate > endDate) ?

                                    <Tooltip title={language.commons.labels.file_download}>
                                        <IconButton
                                            size="small"
                                            sx={{ color: 'gray', marginLeft: '8px' }}
                                            onClick={handleOpen}
                                        >
                                            <HelpOutlineIcon />
                                        </IconButton>
                                    </Tooltip>
                                    :
                                    <Tooltip title={language.commons.labels.file_download}>
                                        <IconButton
                                            size="small"
                                            sx={{
                                                color: 'gray',
                                                marginLeft: '8px',
                                                animation: 'pulse 2s infinite',
                                                '@keyframes pulse': {
                                                    '0%': {
                                                        transform: 'scale(1)',
                                                        color: 'gray',
                                                    },
                                                    '50%': {
                                                        transform: 'scale(1.1)',
                                                        color: '#088AB2', // Açık mavi
                                                    },
                                                    '100%': {
                                                        transform: 'scale(1)',
                                                        color: 'gray',
                                                    },
                                                },
                                            }}
                                            onClick={handleOpen}
                                        >
                                            <HelpOutlineIcon />
                                        </IconButton>
                                    </Tooltip>
                                }

                                <Modal
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="modal-title"
                                    aria-describedby="modal-description"
                                >
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: 800,
                                            bgcolor: 'background.paper',
                                            borderRadius: '10px',
                                            boxShadow: 24,
                                            p: 4,
                                            justifyContent: 'flex-end',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        <h3 id="modal-title">{language.commons.labels.warning_file_download}</h3>
                                        <img
                                            src={require('../../src/assets/images/popUpError.png')}
                                            alt="Pop-up Error"
                                            style={{
                                                display: 'block',
                                                margin: '20px auto',
                                                maxWidth: '100%',
                                                height: 'auto',
                                            }}
                                        />
                                        <p id="modal-description">
                                        {language.commons.labels.browser_message}
                                        </p>
                                        <Button onClick={handleClose} variant="contained" color="primary">
                                            {language.commons.okay}
                                        </Button>
                                    </Box>
                                </Modal>
                            </Grid>
                        </Grid>
                    </Stack>
                </Card >
            </Stack >

        </>
    );
}
